function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Col, Row, Card, CardImg, CardBody } from 'reactstrap';
import mergeStyles from '../utils/StyleMerge';
import Button from './Button';
import renderHTML from 'react-render-html';

class CardGrid extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      hoveredArrow: -1
    });

    _defineProperty(this, "renderSubtitles", subtitle => {
      const {
        styles
      } = this.props;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: styles.subtitle
        }, subtitle)
      );
    });

    _defineProperty(this, "onHoverArrow", index => {
      this.setState({
        hoveredArrow: index
      });
    });

    _defineProperty(this, "leaveHoverArrow", () => {
      this.setState({
        hoveredArrow: -1
      });
    });
  }

  render() {
    const {
      styles,
      cards,
      useRouter,
      history,
      item
    } = this.props;
    const {
      onHoverArrow,
      leaveHoverArrow
    } = this;
    const {
      hoveredArrow
    } = this.state;
    const cardGrid = cards.map((card, index) => {
      return (
        /*#__PURE__*/
        React.createElement(Col, {
          key: index,
          sm: 12,
          md: 6,
          lg: 4,
          style: styles.column
        },
        /*#__PURE__*/
        React.createElement(Card, {
          style: styles.card
        },
        /*#__PURE__*/
        React.createElement("div", {
          onMouseEnter: () => onHoverArrow(index),
          onMouseLeave: () => leaveHoverArrow(),
          onClick: () => card.onClick(),
          style: { ...styles.flippedText,
            height: card.isFlipped ? card.flippedHeight : 0,
            opacity: card.isFlipped ? 1 : 0
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: { ...styles.arrow,
            borderColor: hoveredArrow === index ? styles.arrow.hovered.borderColor : styles.arrow.borderColor
          }
        }),
        /*#__PURE__*/
        React.createElement("div", null, card.flippedText)),
        /*#__PURE__*/
        React.createElement("div", {
          style: styles.header
        }, card.header),
        /*#__PURE__*/
        React.createElement(CardImg, {
          src: card.image.src,
          tag: card.image.tag,
          style: styles.image
        }),
        /*#__PURE__*/
        React.createElement(CardBody, {
          style: styles.body
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: styles.title
        }, card.title),
        /*#__PURE__*/
        React.createElement("hr", {
          style: styles.separator
        }), card.subtitles ?
        /*#__PURE__*/
        React.createElement("div", {
          style: styles.subtitles
        }, card.subtitles.map(subtitle => this.renderSubtitles(subtitle))) : null,
        /*#__PURE__*/
        React.createElement("div", {
          className: 'card-text-wrapper',
          style: styles.text
        }, renderHTML(card.text)),
        /*#__PURE__*/
        React.createElement("div", {
          style: styles.footer
        }, card.button.render ? card.button.render() :
        /*#__PURE__*/
        React.createElement(Button, {
          useRouter: useRouter,
          history: history,
          item: item,
          styles: styles.button
        }, card.button.text)))))
      );
    });
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.container
      },
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.wrapper
      },
      /*#__PURE__*/
      React.createElement(Row, {
        style: styles.row
      }, cardGrid)))
    );
  }

}

const defaultStyles = {
  flippedText: {},
  container: {},
  wrapper: {
    maxWidth: 1200,
    margin: 'auto',
    paddingTop: 20,
    paddingBottom: 20
  },
  row: {
    marginLeft: 40,
    marginRight: 40,
    justifyContent: 'center'
  },
  card: {
    backgroundColor: 'tan',
    color: 'white',
    height: '100%',
    borderRadius: 0,
    border: 'none'
  },
  column: {
    padding: 20
  },
  header: {
    textAlign: 'center',
    padding: 20,
    fontSize: 21
  },
  body: {
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    padding: 40,
    paddingTop: 0,
    display: 'flex'
  },
  image: {
    borderRadius: 0
  },
  title: {
    paddingTop: 20,
    paddingBottom: 20,
    fontSize: 24,
    textAlign: 'center'
  },
  separator: {
    margin: 0,
    borderColor: 'white',
    borderWidth: 0.5,
    marginBottom: 20
  },
  subtitleRow: {},
  subtitle: {
    fontSize: 16,
    textAlign: 'center',
    paddingBottom: 3
  },
  subtitles: {
    paddingBottom: 17
  },
  text: {
    fontSize: 16,
    textAlign: 'left',
    flexGrow: 1
  },
  button: {},
  footer: {
    paddingTop: 20
  }
};
CardGrid.defaultProps = {
  cards: []
};
export default mergeStyles(defaultStyles)(CardGrid);